import translate from '../../../i18n'
import {
  planSubscriptionAutoRenewStatusOptions,
  planSubscriptionStatusOptions,
} from '../../../pages/plan-subscriptions-container/constant'
import { IPlanSubscriptionFilterParams } from '../../../pages/plan-subscriptions-container/share-type'
import { SearchOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, InputNumber, Select } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const { RangePicker } = DatePicker

const PlanSubscriptionFilter = ({
  formData,
  onSearch,
}: {
  formData: IPlanSubscriptionFilterParams | undefined
  onSearch: (value: IPlanSubscriptionFilterParams) => void
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        ...formData,
        currentPeriodEndsAtRange:
          formData.currentPeriodEndsAtFrom && formData.currentPeriodEndsAtTo
            ? [dayjs(formData.currentPeriodEndsAtFrom), dayjs(formData.currentPeriodEndsAtTo)]
            : undefined,
      })
    }
  }, [form, formData])

  const onFinish = (values: any) => {
    const { currentPeriodEndsAtRange, id, planId, userId, ...other } = values
    onSearch({
      ...other,
      id: id ?? undefined,
      planId: planId ?? undefined,
      userId: userId ?? undefined,
      currentPeriodEndsAtFrom: currentPeriodEndsAtRange
        ? dayjs(currentPeriodEndsAtRange[0]).utc().format()
        : undefined,
      currentPeriodEndsAtTo: currentPeriodEndsAtRange
        ? dayjs(currentPeriodEndsAtRange[1]).utc().format()
        : undefined,
    })
  }

  return (
    <Form form={form} layout="inline" style={{ gap: '8px' }} onFinish={onFinish}>
      <Form.Item name="id" label="ID">
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item name="userId" label={translate('planSubscriptions.userId')}>
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item name="planId" label={translate('planSubscriptions.planId')}>
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item name="status" label={translate('planSubscriptions.status')}>
        <Select allowClear options={planSubscriptionStatusOptions} style={{ width: 180 }} />
      </Form.Item>
      <Form.Item name="autoRenewStatus" label={translate('planSubscriptions.autoRenewStatus')}>
        <Select
          allowClear
          options={planSubscriptionAutoRenewStatusOptions}
          style={{ width: 200 }}
        />
      </Form.Item>
      <Form.Item
        name="currentPeriodEndsAtRange"
        label={translate('planSubscriptions.currentPeriodEndsAt')}
      >
        <RangePicker
          showTime={{
            defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
          }}
        />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          {translate('search')}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default PlanSubscriptionFilter
